const STORAGE_KEY = 'refyn_cart_timer_expires_at';
const DURATION_MS = 15 * 60 * 1000;

class RefynCartReservation extends HTMLElement {
  connectedCallback() {
    this.timer = this.querySelector('[data-refyn-cart-reservation-timer]');
    if (!(this.timer instanceof HTMLElement)) return;
    this.start();
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  getExpiry() {
    let expiry = Number(sessionStorage.getItem(STORAGE_KEY));

    if (!Number.isFinite(expiry) || expiry <= Date.now()) {
      expiry = Date.now() + DURATION_MS;
      sessionStorage.setItem(STORAGE_KEY, String(expiry));
    }

    return expiry;
  }

  start() {
    this.expiry = this.getExpiry();

    const render = () => {
      const remaining = Math.max(0, this.expiry - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      this.timer.textContent =
        String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');

      if (remaining <= 0 && this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    };

    render();
    this.intervalId = setInterval(render, 1000);
  }
}

if (!customElements.get('refyn-cart-reservation')) {
  customElements.define('refyn-cart-reservation', RefynCartReservation);
}
